import { GridColumnConfig } from '../../models/gridCoumnConfig';

export const invoiceReportColumns: GridColumnConfig[] = [
  {
    title: 'Customer Name',
    field: 'customerName',
    filter: 'text',
    width: '220',
    searchable: true,
  },
  {
    title: 'Office Name',
    field: 'officeName',
    filter: 'text',
    width: '220',
    searchable: true,
  },
  {
    title: 'Project Name',
    field: 'projectName',
    filter: 'text',
    width: '220',
    searchable: true,
  },
  {
    title: 'Work Order #',
    field: 'workOrderNumber',
    filter: 'text',
    width: '180',
    searchable: true,
    // navigate: true,
  },
  {
    title: 'Invoice#',
    field: 'invoiceNo',
    filter: 'text',
    width: '200',
    searchable: true,
  },
  {
    title: 'Invoice Date',
    field: 'invoiceDate',
    filter: 'text',
    width: '180',
    searchable: true,
  },
  {
    title: 'Invoice Due Date',
    field: 'invoiceDueDate',
    filter: 'text',
    width: '180',
    searchable: true,
  },
  {
    title: 'Purchase Order#',
    field: 'purchaseOrderNos',
    filter: 'text',
    width: '220',
    searchable: true,
  },

  {
    title: 'Lot/Unit#',
    field: 'unitName',
    filter: 'text',
    width: '180',
    searchable: true,
  },

  // {
  //   title: 'Invoice Amount ($)',
  //   field: 'invoiceAmount',
  //   fieldType: 'currency',
  //   filter: 'text',
  //   width: '180',
  //   searchable: true,
  //   format: '{0:n2}',
  // },
  {
    title: 'Invoice Amount ($)',
    field: 'invoiceAmountNumeric',
    // fieldType: 'currency',
    filter: 'numeric',
    width: '180',
    searchable: true,
    format: '{0:n2}',
  },
  {
    title: 'Address',
    field: 'address',
    filter: 'text',
    width: '180',
    searchable: true,
  },
  {
    title: 'Service Name',
    field: 'serviceName',
    filter: 'text',
    width: '200',
    searchable: true,
  },
  {
    title: 'Market Area',
    field: 'marketAreas',
    filter: 'text',
    width: '180',
    searchable: true,
  },
  {
    title: 'Project Department',
    field: 'projectDepartment',
    filter: 'text',
    width: '180',
    searchable: true,
  },
  {
    title: 'Lot Department',
    field: 'unitDepartment',
    filter: 'text',
    width: '180',
    searchable: true,
  },
];
